<template>
  <v-app>
    <v-main>
      <ImageCarousle/>
    </v-main>
  </v-app>
</template>

<script>
import ImageCarousle from './components/ImageCarousle';

export default {
  name: 'App',

  components: {
    ImageCarousle,
  },

  data: () => ({
    //
  }),
};
</script>
